import React, { useState } from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import ListingsMap from "~components/pages/search/listings-map"
import SearchMapMobile from "~components/pages/search/listings-map-mobile"
import { useDisableOverflowBehavior } from "~utils/use-disable-overflow-behavior"
import type { PublicSearchListingFieldsFragment } from "~graphql/generated/graphql"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"

interface Props {
    readonly listings: PublicSearchListingFieldsFragment[]
}

export default function SearchMap({ listings }: Props) {
    useDisableOverflowBehavior()
    const styles = useStyles()
    const [isMapOpen, setIsMapOpen] = useState(false)
    const { isLargerThanTablet } = useTabletMediaQueries()

    return (
        <>
            <Box style={styles.container}>
                <Box style={styles.mapContainer}>
                    {isLargerThanTablet && <ListingsMap listings={listings} />}
                </Box>
            </Box>
            {!isLargerThanTablet && (
                <SearchMapMobile
                    isMapOpen={isMapOpen}
                    setIsMapOpen={setIsMapOpen}
                    listings={listings}
                />
            )}
        </>
    )
}

function useStyles() {
    return componentStyles({
        container: {
            display: { base: "none", md: "flex" },
            flex: 1,
            width: "100%",
            paddingTop: "12px",
            paddingRight: "12px",
            paddingBottom: "12px",
            paddingLeft: "12px",
            boxSizing: "border-box",
            position: "sticky",
            height: "calc(100vh - 72px)",
            top: "72px",
        },
        mapContainer: {
            width: "100%",
            height: "100%",
            borderRadius: "16px",
            overflow: "hidden",
        },
    })
}
